/** join a facet array into a comma-separated query param, omitted when empty. */
export function csvParam(values: string[] | undefined): string | undefined {
  return values && values.length > 0 ? values.join(',') : undefined
}
